module.exports = "/media/harbour_color.22cdf68d.png";